import React, { useEffect, useState, memo, useCallback, useRef } from "react";
// import { FixedSizeList } from "react-window";
import { useGlobalState } from "../../services/hostelConst";
import { useParams } from "react-router-dom";
import {
  Row,
  Col,
  Nav,
  Tab,
  Card,
  Dropdown,
  OverlayTrigger,
  Popover,
  Button,
  Table,
} from "react-bootstrap";
import DetailsPageNavigation from "../../views/dashboard/widget/detailsPageNavigation";
import MasterActions from "../../views/dashboard/widget/MasterActions";
import Select from "react-select";
import "../../assets/css/expandablecard.css";
import {
  FiUser,
  FiCalendar,
  FiTrash2,
  FiCheckCircle,
  FiAlertCircle,
  FiEdit,
  FiXCircle,
  FiSearch,
  FiPlus,
  FiMoreVertical,
  ThreeDotsVertical,
  FiChevronDown,
  FiChevronUp,
  FiChevronRight,
  FiHome,
} from "react-icons/fi";
import {
  getRoleDetails,
  getRolesList,
  deleteRole,
  updateRoleStatus,
  updateRole,
  getPolicyNameList,
  getServices,
  getRoleUserList,
  addRoleUser,
  deleteRoleUser,
} from "../../services/Users-services";
import {
  showErrorMessages,
  getMethods,
  callToast,
} from "../../services/utilityFunctions";
import { DropdownIndicator } from "../../views/dashboard/widget/tableWidget";
import { useNavigate } from "react-router-dom";
import AddRoleForm from "../FormComponents/AddRole";
import { getLocalStorageData } from "../../services/axiosComponent";
import MasterTable2 from "../../views/dashboard/widget/MasterTabe2";
import AddRoleUser from "../FormComponents/AddRoleUser";
import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useSelector, useDispatch } from "react-redux";
import {
  closeModal,
  openModal,
} from "../../services/redux/reducers/modalSlice";
const RolesDetailsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState({});
  const [isServiceSelected, setIsServiceSelected] = useState(false);

  const [details, setDetails] = useState(null);
  const [updateDetails, setUpdateDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [updateLoading, setUpdateLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const getRoleDetailsData = async ({ id, isLoading = true }) => {
    if (isLoading) setLoading(true);

    const res = await getRoleDetails(id);
    if (res.status == "success") {
      setIsEditMode(false);
      setDetails(res.data);
      dispatch(openModal({ data: res.data }));
      setUpdateDetails(JSON.parse(JSON.stringify(res.data)));
      var expandedArr = {};
      console.log(res.data["_ACCESSIBILITIES_"], "update details inrole");
      res.data["_ACCESSIBILITIES_"].map((item, index) => {
        expandedArr[item.service] = false;
      });
      setIsExpanded(expandedArr);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    if (isLoading) setLoading(false);
  };
  const handleSaveChanges = async () => {
    setUpdateLoading(true);
    console.log(updateDetails, "updateDetails");
    const dataToSubmit = {
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"],
      roleDescription: updateDetails.DESCRIPTION,
      roleName: updateDetails.NAME,
      planId: getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_PLAN"],
      updatePolicy: "Y",
      rolePolicy: JSON.stringify(
        updateDetails._ACCESSIBILITIES_.map((item) => ({
          ...item,
          policies: JSON.stringify(item.policies),
        }))
      ),
      id: updateDetails._ID,
    };
    console.log(dataToSubmit, "updateDetails submit");
    var res = await updateRole(dataToSubmit);

    if (res.status == "success") {
      await getRoleDetailsData({ id, isLoading: false });
      callToast("success", "Role updated successfully");
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setUpdateLoading(false);
  };
  var i = 0;
  useEffect(() => {
    getRoleDetailsData({ id });
    dispatch(
      openModal({
        body: (
          <AddRoleForm
            navigate={navigate}
            refresh={() => getRoleDetailsData({ id, isLoading: false })}
          />
        ),
      })
    );

    return () => {};
  }, []);

  const [activeTab, setActiveTab] = useState("first");

  return (
    <>
      {loading ? (
        <center>
          <div class="spinner-border text-primary" role="status">
     
          </div>
        </center>
      ) : (
        <Row className="row  d-flex flex-column gap-0">
          <RoleDetailsCard
            handleSaveChanges={handleSaveChanges}
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            updateLoading={updateLoading}
            isExpanded={isExpanded}
            updateDetails={updateDetails}
            setUpdateDetails={setUpdateDetails}
            setIsExpanded={setIsExpanded}
            isServiceSelected={isServiceSelected}
            setIsServiceSelected={setIsServiceSelected}
            details={details}
            getMethods={getMethods}
            deleteRole={deleteRole}
            updateRoleStatus={updateRoleStatus}
            updateRole={updateRole}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            getRoleDetailsData={getRoleDetailsData}
            id={id}
          />
        </Row>
      )}
    </>
  );
};

export default RolesDetailsPage;

// Add this CSS transition

const RoleDetailsCard = ({
  details,
  updateDetails,
  setUpdateDetails,
  getMethods,
  deleteRole,
  updateRoleStatus,
  updateRole,
  getRoleDetailsData,
  handleSaveChanges,
  updateLoading,
  isEditMode,
  setIsEditMode,
  activeTab,
  setActiveTab,

  id,
}) => {
  function getMissingServices(list1, list2) {
    console.log("haq", list1, list2);
    const serviceNamesInList2 = new Set(list2.map((item) => item.id));
    console.log(serviceNamesInList2, "haq");
    return list1
      .filter((item) => !serviceNamesInList2.has(item._SERVICE))
      .map((item) => ({
        value: item._SERVICE,
        label: item.NAME,
        name: item.NAME,
      }));
  }
  const navigate = useNavigate();
  const [expandedService, setExpandedService] = useState(null);
  var i = 0;

  const [serviceList, setServiceList] = useState([]);
  const [serviceListLoading, setServiceListLoading] = useState(false);

  const getServicesData = async () => {
    setServiceListLoading(true);

    var res = await getServices(
      getLocalStorageData("profileDetails")["_ORGANIZATION_"]["_ID"]
    );
    if (res.status == "success") {
      var data = getMissingServices(res.data, details["_ACCESSIBILITIES_"]);

      setServiceList(data);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setServiceListLoading(false);
  };
  useEffect(() => {
    getServicesData();
    return () => {};
  }, []);
  const handleExpandedToggle = useCallback((service) => {
    setExpandedService((prev) => (prev === service ? null : service));
  }, []);

  const [selectedService, setSelectedService] = useState(null);
  return (
    <Tab.Container
      key="persistent-tabs"
      activeKey={activeTab}
      onSelect={(key) => {
        if (key) {
          setActiveTab(key);
        }
      }}
    >
      <div className=" ">
        <Row className="row m-0 p-0 g-0" style={{ margin: "0px" }}>
          <Col lg="12" className="mb-0 pb-0 ">
            <Card
              className="position-relative border-0 transition-all"
              style={{ borderRadius: "1rem", transition: "0.3s" }}
            >
              <Card.Body className="p-3 px-lg-4 py-lg-3 position-relative">
                {/* Add Icon */}
                <Row className="">
                  {/* ... Existing left section content ... */}
                  <Col className="d-flex flex-column align-align-items-start w-100  ">
                    <DetailsPageNavigation list={["Roles", "Details"]} />
                    <Col className="pe-0 me-0 d-flex align-items-center  ">
                      <div className="">
                        <div className="d-flex align-items-start gap-2 mb-2">
                          <h3
                            className="mb-0 fw-bold fs-4 text-truncate"
                            style={{
                              background:
                                "linear-gradient(45deg, #2b2b2b, #4a4a4a)",
                              WebkitBackgroundClip: "text",
                              WebkitTextFillColor: "transparent",
                            }}
                          >
                            {details?.NAME}
                          </h3>
                        </div>
                        <p
                          className="text-muted mb-2 fs-6"
                          style={{
                            lineHeight: 1.5,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {details?.DESCRIPTION || "No description available"}
                        </p>
                      </div>
                    </Col>
                    <Nav
                      as="ul"
                      className="nav-tabs mb-0 text-center profile-tab"
                      data-toggle="slider-tab"
                      id="profile-pills-tab"
                      role="tablist"
                    >
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="first"
                          active={activeTab === "first"}
                        >
                          Roles
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className="me-3">
                        <Nav.Link
                          eventKey="third"
                          active={activeTab === "third"}
                        >
                          Users
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>
                  {/* Right Section */}
                  <Col lg="3" className="h-100">
                    <div
                      className="d-flex flex-column gap-1 justify-content-end align-align-items-end  text-end"
                      style={{
                        gap: "clamp(0.5rem, 2vh, 1rem)",
                        minHeight: "17vh",
                        padding: "clamp(0.5rem, 0.5vh, 1.5rem) 0",
                      }}
                    >
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2 ">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 2vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiUser className="text-primary fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details["CREATED BY"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 2vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details["LAST MODIFIED"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 2vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <FiEdit className="text-danger fs-6" />
                        </div>
                        <div>
                          <div
                            className={`text-dark fw-medium`}
                            style={{ fontSize: "0.875rem" }}
                          >
                            {details["MODIFIED BY"]}
                          </div>
                          {/* <small className="text-muted">{subLabel}</small> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-2 hover-bg-light rounded-2">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{
                            width: "clamp(24px, 4vw, 32px)",
                            height: "clamp(24px, 2vw, 32px)",
                            flexShrink: 0,
                          }}
                        >
                          <MasterActions
                            actions={{
                              edit: details["TYPE"] == "CUSTOM-ROLE",
                              delete: details["TYPE"] == "CUSTOM-ROLE",
                              status: true,
                            }}
                            methods={getMethods("User Management", "Roles")}
                            refresh={() =>
                              getRoleDetailsData({ id, isLoading: false })
                            }
                            deleteRow={deleteRole}
                            updateStatus={updateRoleStatus}
                            updateRow={updateRole}
                            isDetailsPage={true}
                            item={details}
                          />
                        </div>
                        <div
                          className="text-dark fw-medium"
                          style={{
                            fontSize: "clamp(0.75rem, 1.5vw, 0.875rem)",
                          }}
                        >
                          Show Options
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                {/* Expandable Section */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Tab.Content className="profile-content">
          <Tab.Pane eventKey="first" id="profile-feed">
            <Card className=" shadow-lg rounded-4 border-0 mt-0">
              <Card.Header
                style={{
                  backgroundColor: "#FFFFFFFF",
                  padding: "1.25rem 1.5rem",
                  borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.03)",
                  borderRadius: "12px 12px 0 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "1.5rem",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1.25rem",
                    }}
                  >
                    <h3
                      style={{
                        margin: 0,
                        fontWeight: 600,
                        fontSize: "1.375rem",
                        color: "#2d3436",
                        letterSpacing: "-0.25px",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                      }}
                    >
                      <div
                        style={{
                          width: "4px",
                          height: "24px",
                          backgroundColor: "#4a90e2",
                          borderRadius: "2px",
                        }}
                      />
                      Services
                    </h3>

                    <div
                      className=""
                      style={{
                        width: "1px",
                        height: "28px",
                        // backgroundColor: "rgba(0, 0, 0, 0.12)",
                        display: "none",
                        "@media (min-width: 576px)": { display: "block" },
                      }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1.25rem",
                    }}
                  >
                    {isEditMode && (
                      <Button
                        onClick={handleSaveChanges}
                        size="md"
                        className="px-4 py-2"
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: 500,

                          boxShadow: "0 2px 4px rgba(13, 110, 253, 0.15)",
                          transition: "all 0.2s ease",
                        }}
                      >
                        {updateLoading ? (
                          <div class="spinner-border text-light" role="status">
                     
                          </div>
                        ) : (
                          "Save"
                        )}
                      </Button>
                    )}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                      }}
                    >
                      <label
                        style={{
                          display: "flex",
                          flexDirection: "column", // Changed to column
                          alignItems: "center",
                          gap: "0.5rem",
                          cursor: "pointer",
                          userSelect: "none",
                        }}
                      >
                        {/* {details["_ACCESSIBILITIES_"].length == 0 && (
                          <span
                            style={{
                              color: "#495057",
                              fontSize: "0.75rem", // Slightly smaller font for better appearance
                              fontWeight: 500,
                              marginTop: "2px", // Added small top margin
                            }}
                          >
                            Add Services
                          </span>
                        )} */}
                        {details["TYPE"] == "CUSTOM-ROLE" &&
                          updateDetails["_ACCESSIBILITIES_"].length != 0 && (
                            <div
                              style={{
                                position: "relative",
                                width: "20px",
                                height: "20px",
                                border: "2px solid #ced4da",
                                borderRadius: "4px",
                                transition: "all 0.2s ease",
                                backgroundColor: setIsEditMode
                                  ? "#e3f2fd"
                                  : "transparent",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isEditMode}
                                onChange={(e) => {
                                  setIsEditMode(e.target.checked);
                                  setUpdateDetails(details);
                                  getServicesData();
                                  // setServiceList(
                                  //  (prev)=>{

                                  //  }
                                  // );
                                }}
                                style={{
                                  opacity: 0,
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                }}
                              />
                              {isEditMode && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    color: "#2196f3",
                                    fontSize: "14px",
                                  }}
                                >
                                  ✓
                                </div>
                              )}
                            </div>
                          )}
                        {details["TYPE"] == "CUSTOM-ROLE" &&
                          updateDetails["_ACCESSIBILITIES_"].length != 0 && (
                            <span
                              style={{
                                color: "#495057",
                                fontSize: "0.75rem", // Slightly smaller font for better appearance
                                fontWeight: 500,
                                marginTop: "2px", // Added small top margin
                              }}
                            >
                              Edit Mode
                            </span>
                          )}
                      </label>
                    </div>

                    {details["TYPE"] == "CUSTOM-ROLE" && (
                      <div style={{ position: "relative", width: "340px" }}>
                        <div
                          style={{
                            position: "absolute",
                            left: "12px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 2,
                            color: "#0d6efd",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <FiPlus size={16} />
                        </div>
                        {
                          <Select
                            options={serviceList}
                            placeholder="Add Service"
                            components={
                              serviceListLoading ? { DropdownIndicator } : null
                            }
                            onChange={(selected) => {
                              if (!selected) {
                                setIsEditMode(false);
                                return;
                              }
                              setSelectedService(selected.value);
                              setServiceList((prev) =>
                                prev.filter(
                                  (item) => item.value !== selected.value
                                )
                              );
                              setUpdateDetails((prev) => {
                                const newDetails = JSON.parse(
                                  JSON.stringify(prev)
                                );

                                const newAccessibility = {
                                  service: selected.name,
                                  id: selected.value,
                                  new: true,
                                  policies: [],
                                };

                                newDetails["_ACCESSIBILITIES_"] = [
                                  newAccessibility,
                                  ...newDetails["_ACCESSIBILITIES_"],
                                ];

                                return newDetails;
                              });

                              setIsEditMode(true);
                            }}
                            styles={{
                              container: (base) => ({
                                ...base,
                                "&:hover": {
                                  filter: "brightness(98%)",
                                },
                              }),
                              control: (base) => ({
                                ...base,
                                minHeight: "42px",
                                borderRadius: "10px",
                                border: "1px solid rgba(0,0,0,0.08)",
                                backgroundColor: "rgba(255,255,255,0.8)",
                                backdropFilter: "blur(8px)",
                                boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                                paddingLeft: "32px",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                  borderColor: "#90caf9",
                                  backgroundColor: "rgba(255,255,255,0.95)",
                                },
                                "&:focus-within": {
                                  borderColor: "#64b5f6",
                                  boxShadow:
                                    "0 0 0 3px rgba(100, 181, 246, 0.15)",
                                  backgroundColor: "#ffffff",
                                },
                              }),
                              menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                                overflow: "hidden",

                                backgroundColor: "#ffffff",
                                borderRadius: "12px",
                                border: "1px solid rgba(0,0,0,0.08)",
                                boxShadow:
                                  "0 4px 20px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
                                animation: "selectMenuFade 0.2s ease",
                              }),
                              menuList: (base) => ({
                                ...base,
                                padding: "6px",
                                "::-webkit-scrollbar": {
                                  width: "6px",
                                },
                                "::-webkit-scrollbar-track": {
                                  background: "transparent",
                                },
                                "::-webkit-scrollbar-thumb": {
                                  background: "#d1d5db",
                                  borderRadius: "3px",
                                },
                              }),
                              option: (base, state) => ({
                                ...base,
                                padding: "10px 12px",
                                borderRadius: "8px",
                                backgroundColor: state.isSelected
                                  ? "rgba(13, 110, 253, 0.08)"
                                  : state.isFocused
                                  ? "rgba(13, 110, 253, 0.04)"
                                  : "transparent",
                                color: state.isSelected ? "#0d6efd" : "#495057",
                                fontSize: "0.875rem",
                                fontWeight: state.isSelected ? 500 : 400,
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                "&:active": {
                                  backgroundColor: "rgba(13, 110, 253, 0.12)",
                                },
                              }),
                              dropdownIndicator: (base) => ({
                                ...base,
                                color: "#6c757d",
                                padding: "0 8px",
                                "&:hover": {
                                  color: "#495057",
                                },
                              }),
                              indicatorSeparator: () => ({
                                display: "none",
                              }),
                              valueContainer: (base) => ({
                                ...base,
                                padding: "2px 8px",
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "#6c757d",
                                fontSize: "0.875rem",
                              }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition="absolute"
                          />
                        }
                      </div>
                    )}
                  </div>
                </div>
              </Card.Header>

              <Card.Body className="pt-1">
                {updateDetails["_ACCESSIBILITIES_"].map((item, index) => {
                  console.log(item, "item");
                  return (
                    <ExpandableCard
                      key={index}
                      setServiceList={setServiceList}
                      int={index}
                      isEditMode={isEditMode}
                      setIsEditMode={setIsEditMode}
                      isExpanded={expandedService === item.service}
                      setIsExpanded={() => handleExpandedToggle(item.service)}
                      title={item.service}
                      setUpdateDetails={setUpdateDetails}
                      id={item.id}
                      isNew={item?.new}
                      tableData={item.policies}
                    />
                  );
                })}
              </Card.Body>
            </Card>
          </Tab.Pane>
          <Tab.Pane eventKey="third" id="profile-friends">
            {/* <MasterTable2
              getList={getRoleUserList}
              roleId={id}
              addRow={addRoleUser}
              deleteRow={deleteRoleUser}
              id={id}
              AddForm={AddRoleUser}
              actions={{
                delete: true,
              }}
              details={details}
              methods={getMethods("User Management", "Roles")}
              tab1={"User Management"}
              tab2={"Roles"}
            /> */}
            <MasterTable
              getTableData={getRoleUserList}
              roleId={id}
              AddForm={AddRoleUser}
              actions={{
                delete: true,
              }}
              tab1={"User Management"}
              tab2="Role Users"
              deleteRow={deleteRoleUser}
              details={details}
              up
            />
          </Tab.Pane>
        </Tab.Content>
      </div>
    </Tab.Container>
  );
};

const ExpandableCard = memo(
  ({
    int,

    id,
    isExpanded,
    setIsExpanded,
    title,
    setServiceList,
    tableData,
    setIsEditMode,
    isEditMode = false,
    setUpdateDetails,
    isNew,
  }) => {
    const navigate = useNavigate();
    const { openConcentModal, closeConcentModal } = useGlobalState();
    const [showPopOver, setShowPopOver] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [showAddSelect, setShowAddSelect] = useState(false);
    const [policyNameList, setPolicyNameList] = useState([]);
    const [policyListLoading, setPolicyListLoading] = useState(false);

    function getMissingElementsByName(list1, list2) {
      const namesSet = new Set(list2.map((item) => item.name)); // Extract names from List 2 into a Set

      return list1
        .filter((item) => !namesSet.has(item.name)) // Filter items not present in List 2
        .map((item) => ({ ...item, value: item.name, label: item.name })); // Add 'label' field
    }
    const getPloicyNameListData = async () => {
      setPolicyListLoading(true);

      var res = await getPolicyNameList(id);
      if (res.status == "success") {
        if (res.data["_POLICIES_"] && res.data["_POLICIES_"].length > 0) {
          res.data["_POLICIES_"].forEach((item) => {
            item.permissions = "POST,PUT,DELETE,PATCH";
          });
        }
        console.log("update details :1", res.data);

        if (isNew == true) {
          setUpdateDetails((prev) => {
            const newDetails = JSON.parse(JSON.stringify(prev));
            newDetails._ACCESSIBILITIES_[int].policies = res.data["_POLICIES_"];
            return newDetails;
          });
        } else {
          setPolicyNameList(
            getMissingElementsByName(res.data?.["_POLICIES_"], tableData)
          );
        }
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setPolicyListLoading(false);
    };
    const selectAllPoliciy = (select) => {
      setUpdateDetails((prev) => {
        // Option 1: Deep clone approach (your current pattern)
        const newDetails = JSON.parse(JSON.stringify(prev));
        newDetails._ACCESSIBILITIES_[int].policies =
          newDetails._ACCESSIBILITIES_[int].policies.map((policy) => ({
            ...policy,
            permissions: select ? "POST,PUT,DELETE,PATCH" : "",
          }));
        return newDetails;
      });
      setSelectAll(select);
    };
    
    const checkIfAllPoliciesAreSelected = ({ data = tableData } = {}) => {
      const allSelected = data.every(
        (item) =>
          item.permissions.includes("POST") &&
          item.permissions.includes("PUT") &&
          item.permissions.includes("DELETE") &&
          item.permissions.includes("PATCH")
      );

      if (!allSelected) {
        setSelectAll(false);
        return;
      }

      setSelectAll(true);
      return;
    };

    useEffect(() => {
      checkIfAllPoliciesAreSelected();
      getPloicyNameListData();
      return () => {};
    }, [id]);
    function modifyMethods(methods, method, add) {
      console.log(methods, method, add);
      let methodList = methods.split(",").filter(Boolean); // Removes empty strings
      if (add) {
        if (!methodList.includes(method)) {
          methodList.push(method);
        }
      } else {
        methodList = methodList.filter((m) => m !== method);
      }
      return methodList.join(",");
    }
    return (
      tableData && (
        <div className="container mb-3 ">
          <Card
            className=" border-1 m-2 bg-white"
            style={{
              border: "2px solid rgba(0, 0, 0, 0.05)",
              boxShadow:
                "0 8px 24px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.03)",
            }}
          >
            {/* Header remains unchanged */}
            <div
              onClick={setIsExpanded}
              className="card-header d-flex justify-content-between align-items-center py-3 px-4"
              style={{
                cursor: "pointer",
                backgroundColor: "transparent",
                borderBottom: isExpanded
                  ? "1px solid rgba(0,0,0,0.08)"
                  : "1px solid transparent",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <h6
                className="mb-0 fw-semibold text-truncate"
                style={{
                  background: "linear-gradient(45deg, #2b2b2b, #404040)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  letterSpacing: "-0.25px",
                }}
              >
                {title}
              </h6>

              <div className="d-flex align-items-center gap-3">
                {isExpanded && isEditMode && (
                  <div
                    className="form-check form-switch "
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheck"
                      checked={selectAll}
                      onChange={(e) => {
                        e.stopPropagation();
                        selectAllPoliciy(e.target.checked);
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheck"
                    >
                      {"Select All"}
                    </label>
                  </div>
                )}
                {isExpanded && isEditMode && (
                  <div
                    className="d-flex align-items-center gap-2"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div
                      style={{
                        position: "relative",
                        height: "34px",
                        width: showAddSelect ? "150px" : "34px",
                        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                      }}
                    >
                      <FiPlus
                        size={18}
                        className="text-primary hover-scale transition-all"
                        style={{
                          position: "absolute",
                          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                          cursor: "pointer",
                          opacity: showAddSelect ? 0 : 1,
                          transform: showAddSelect ? "scale(0.8)" : "scale(1)",
                          pointerEvents: showAddSelect ? "none" : "auto",
                          left: 0,
                          top: "6px",
                        }}
                        onClick={() => setShowAddSelect(true)}
                      />

                      <div
                        style={{
                          position: "absolute",
                          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                          opacity: showAddSelect ? 1 : 0,
                          transform: showAddSelect ? "scale(1)" : "scale(0.8)",
                          width: "150px",
                          pointerEvents: showAddSelect ? "auto" : "none",
                          left: 0,
                          top: 0,
                        }}
                      >
                        <Select
                          components={
                            policyListLoading
                              ? {
                                  DropdownIndicator: DropdownIndicator,
                                }
                              : null
                          }
                          options={policyNameList}
                          defaultValue={{ value: "item", label: "Add Policy" }}
                          isSearchable={false}
                          onChange={(selected) => {
                            setUpdateDetails((prev) => {
                              const newDetails = JSON.parse(
                                JSON.stringify(prev)
                              );
                              newDetails._ACCESSIBILITIES_[int].policies.push({
                                name: selected.value,
                                path: selected.path,

                                permissions: "",
                              });
                              checkIfAllPoliciesAreSelected({
                                data: newDetails._ACCESSIBILITIES_[int]
                                  .policies,
                              });
                              console.log("new details", newDetails);
                              return newDetails;
                            });
                            setPolicyNameList((prev) => {
                              return prev.filter(
                                (item) => item.value !== selected.value
                              );
                            });

                            setShowAddSelect(false);
                          }}
                          styles={{
                            container: (base) => ({
                              ...base,
                              transition:
                                "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                              width: showAddSelect ? "150px" : "0",
                            }),
                            control: (base) => ({
                              ...base,
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              border: "none",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                              borderRadius: "6px",
                              padding: "2px 8px",
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                              },
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? "rgba(13, 110, 253, 0.1)"
                                : state.isFocused
                                ? "rgba(13, 110, 253, 0.05)"
                                : "transparent",
                              color: state.isSelected ? "#0d6efd" : "#495057",
                              cursor: "pointer",
                              "&:active": {
                                backgroundColor: "rgba(13, 110, 253, 0.15)",
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999, // Ensures it's the topmost layer
                              backgroundColor: "white",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              border: "1px solid rgba(0,0,0,0.08)",
                              borderRadius: "8px",
                              overflow: "hidden",
                              position: "absolute",
                            }),
                            menuList: (base) => ({
                              ...base,
                              padding: "4px",
                              maxHeight: "200px",
                              overflowY: "auto",
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: "#6c757d",
                              "&:hover": {
                                color: "#495057",
                              },
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              padding: "0 4px",
                            }),
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="absolute"
                        />
                      </div>
                    </div>
                  </div>
                )}

                {isEditMode && (
                  <FiTrash2
                    size={18}
                    className="text-danger hover-opacity"
                    style={{
                      transition: "all 0.2s",

                      cursor: "pointer",
                      opacity: 0.7,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUpdateDetails((prev) => {
                        const newDetails = JSON.parse(JSON.stringify(prev));
                        newDetails._ACCESSIBILITIES_ =
                          newDetails._ACCESSIBILITIES_.filter(
                            (item) => item.service !== title
                          );
                        setServiceList((prev) => {
                          return [
                            {
                              value: id,
                              label: title,
                              name: title,
                            },
                            ...prev,
                          ];
                        });
                        // if (newDetails._ACCESSIBILITIES_.length == 0)
                        //   setIsEditMode(false);
                        return newDetails;
                      });
                    }}
                  />
                )}

                <FiChevronDown
                  size={18}
                  className={`text-secondary transition-all ${
                    isExpanded ? "rotate-180" : ""
                  }`}
                  style={{
                    transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    opacity: 0.8,
                  }}
                />
              </div>
            </div>

            <div
              style={{
                maxHeight: isExpanded ? "50vh" : "0",
                overflow: "hidden",
                transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <Card.Body className=" bg-white ">
                <div
                  className="table-responsive border-0  p-0  mb-0"
                  style={{
                    // background: "rgba(255, 255, 255, 0.3)",
                    backdropFilter: "blur(6px)",
                    borderRadius: "15px",
                  }}
                >
                  <Table
                    hover
                    style={{
                      width: "100%",
                      borderRadius: "15px",
                      // backgroundColor: "rgba(255, 255, 255, 0.2)",
                      border: "1px solid rgba(0, 0, 0, 0.08)",
                      borderCollapse: "separate",
                      borderSpacing: 0,
                      tableLayout: "fixed", // Add fixed table layout
                    }}
                    className="pb-0 mb-0"
                  >
                    <thead
                      style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                        backgroundColor: "rgba(199, 199, 207, 0.95)",
                        backdropFilter: "blur(8px)",
                        display: "table", // Fix header width
                        width: "100%", // Match table width
                      }}
                    >
                      <tr>
                        <th
                          className=""
                          style={{
                            fontSize: "0.813rem",
                            fontWeight: 600,
                            color: "#495057",
                            width: "24%",
                            textAlign: "left",
                            borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                            borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                          }}
                        >
                          Permission
                        </th>
                        {["CREATE", "UPDATE", "DELETE", "PATCH"].map(
                          (action) => (
                            <th
                              key={action}
                              style={{
                                padding: "0.875rem 1rem",
                                fontSize: "0.813rem",
                                fontWeight: 600,
                                color: "#495057",
                                width: "20%",
                                textAlign: "center",
                                borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              {action}
                            </th>
                          )
                        )}
                        {isEditMode && (
                          <th
                            style={{
                              width: "10%",
                              padding: "1rem",
                              fontSize: "0.813rem",
                              fontWeight: 600,
                              color: "#495057",
                              textAlign: "center",
                              borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Remove
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody
                      className="pb-0 mb-0"
                      style={{
                        display: "block",
                        maxHeight: "35vh",
                        overflowY: "auto",
                        width: "100%", // Add full width
                      }}
                    >
                      {tableData.map((item, index) => (
                        <tr
                          key={index}
                          style={{
                            display: "table", // Maintain table layout
                            width: "100%", // Match header width
                            tableLayout: "fixed", // Keep consistent columns
                            backgroundColor: "rgba(255, 255, 255, 0.15)",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
                            transition: "background-color 0.2s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "rgba(255, 255, 255, 0.25)")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "rgba(255, 255, 255, 0.15)")
                          }
                        >
                          <td
                            style={{
                              fontSize: "0.813rem",
                              fontWeight: 500,
                              color: "#2d3436",
                              width: "25%",
                              borderRight: "1px solid rgba(0, 0, 0, 0.05)",
                            }}
                          >
                            {item.name}
                          </td>
                          {["POST", "PUT", "DELETE", "PATCH"].map(
                            (method, idx) => (
                              <td
                                key={idx}
                                style={{
                                  padding: "0.75rem 1rem",
                                  textAlign: "center",
                                  width: "20%",
                                  borderRight:
                                    idx < 2
                                      ? "1px solid rgba(0, 0, 0, 0.05)"
                                      : "none",
                                }}
                              >
                                {isEditMode ? (
                                  <div>
                                    <input
                                      checked={item.permissions.includes(
                                        method
                                      )}
                                      onClick={(e) => {
                                        setUpdateDetails((prev) => {
                                          const newDetails = JSON.parse(
                                            JSON.stringify(prev)
                                          );

                                          newDetails._ACCESSIBILITIES_[
                                            int
                                          ].policies[index].permissions =
                                            modifyMethods(
                                              item.permissions,
                                              method,
                                              e.target.checked
                                            );
                                          checkIfAllPoliciesAreSelected({
                                            data: newDetails._ACCESSIBILITIES_[
                                              int
                                            ].policies,
                                          });
                                          return newDetails;
                                        });
                                      }}
                                      class="form-check-input"
                                      type="checkbox"
                                      id="checkboxNoLabel"
                                      value=""
                                      aria-label="..."
                                    />
                                  </div>
                                ) : item.permissions.includes(method) ? (
                                  <FiCheckCircle
                                    size={18}
                                    style={{
                                      color: "#28a745",
                                      opacity: 0.9,
                                      transition: "transform 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1.1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                  />
                                ) : (
                                  <FiXCircle
                                    size={18}
                                    style={{
                                      color: "#dc3545",
                                      opacity: 0.9,
                                      transition: "transform 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1.1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                  />
                                )}
                              </td>
                            )
                          )}

                          {isEditMode && (
                            <td
                              style={{
                                width: "10%",
                                padding: "0.75rem 1rem",
                                textAlign: "center",
                              }}
                            >
                              <OverlayTrigger
                                show={showPopOver}
                                trigger="click"
                                placement="bottom" // Changed to left to avoid getting cut off
                                overlay={
                                  <Popover
                                    id="popover-basic"
                                    style={{
                                      backgroundColor: "#fff",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      border: "1px solid rgba(0,0,0,0.1)",
                                      borderRadius: "8px",
                                      zIndex: 1000,
                                    }}
                                  >
                                    <Popover.Body
                                      style={{
                                        padding: "0.75rem 1rem",
                                        fontSize: "0.875rem",

                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <FiAlertCircle size={16} />
                                        At least one permission required
                                      </div>
                                    </Popover.Body>
                                  </Popover>
                                }
                              >
                                <div style={{ position: "relative" }}>
                                  <FiTrash2
                                    size={18}
                                    className="text-danger"
                                    style={{
                                      cursor: "pointer",
                                      opacity: 0.7,
                                      transition: "all 0.2s ease",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.opacity = 1)
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.opacity = 0.7)
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setPolicyNameList((prev) => {
                                        return [
                                          ...prev,
                                          {
                                            name: item.name,
                                            value: item.name,
                                            label: item.name,
                                          },
                                        ];
                                      });
                                      setUpdateDetails((prev) => {
                                        const newDetails = JSON.parse(
                                          JSON.stringify(prev)
                                        );
                                        const currentPolicies =
                                          newDetails._ACCESSIBILITIES_[int]
                                            .policies;

                                        if (currentPolicies.length <= 1) {
                                          setShowPopOver(true);
                                          setTimeout(
                                            () => setShowPopOver(false),
                                            2000
                                          ); // Increased duration
                                          return prev;
                                        }

                                        newDetails._ACCESSIBILITIES_[
                                          int
                                        ].policies = currentPolicies.filter(
                                          (policy) => policy.name !== item.name
                                        );
                                        checkIfAllPoliciesAreSelected({
                                          data: newDetails._ACCESSIBILITIES_[
                                            int
                                          ].policies,
                                        });
                                        return newDetails;
                                      });
                                    }}
                                  />
                                </div>
                              </OverlayTrigger>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </div>
          </Card>
        </div>
      )
    );
  }
);
